module.exports = __webpack_public_path__ + "img/12-img.162824d1.jpg";